import React, { useContext } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UserOutlined, HomeOutlined, HistoryOutlined, LogoutOutlined } from '@ant-design/icons';
import { AuthContext } from '../../context/AuthContext';

const { Header, Content, Footer } = Layout;

const MainLayout = ({ children }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className="logo" style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>
            安全培训考试系统
          </div>
          <Menu theme="dark" mode="horizontal" selectedKeys={[location.pathname]} style={{ flex: 1 }}>
            <Menu.Item key="/" icon={<HomeOutlined />}>
              <Link to="/">考试中心</Link>
            </Menu.Item>
            <Menu.Item key="/history" icon={<HistoryOutlined />}>
              <Link to="/history">考试历史</Link>
            </Menu.Item>
          </Menu>
        </div>
        <div>
          <Dropdown overlay={userMenu} placement="bottomRight">
            <Button type="text" style={{ color: 'white' }}>
              <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
              {user?.name || '用户'}
            </Button>
          </Dropdown>
        </div>
      </Header>
      <Content style={{ padding: '0 50px' }}>
        <div className="site-layout-content" style={{ margin: '16px 0', padding: 24, minHeight: 280, background: '#fff' }}>
          {children}
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>安全培训考试系统 ©{new Date().getFullYear()} 版权所有</Footer>
    </Layout>
  );
};

export default MainLayout; 